import { Directive, AfterViewInit, OnDestroy } from "@angular/core";
/**
 * floating table header when user scroll table
 */
@Directive({
  selector: '[appFloatingTableHeader]'
})
export class FloatingTableHeaderDirective implements AfterViewInit, OnDestroy {
    private tableHasContentElement: HTMLElement;
    private targetElement: HTMLElement;

    ngAfterViewInit(): void {
        this.tableHasContentElement = document.getElementById("list-content") as HTMLElement;
        this.targetElement = document.getElementsByTagName("footer").item(0) as HTMLElement;
        console.log("ngAfterViewInit", this.tableHasContentElement, this.targetElement);
        this.resetTableHeight();
        window.addEventListener("resize", this.resetTableHeight.bind(this));
    }

    private resetTableHeight(): void {
        setTimeout(() => {
            console.log("resetTableHeight");
            if(this.targetElement&& this.tableHasContentElement) {
                let distance = this.targetElement.getBoundingClientRect().top - this.tableHasContentElement.getBoundingClientRect().top;
                this.tableHasContentElement.style.maxHeight = `${Math.round(distance)}px`;
            }
        }, 0);
    };

    ngOnDestroy(): void {
        window.removeEventListener("resize", this.resetTableHeight.bind(this));
    }
}
